<template>
<div class="footer-container">
  <div class="footer-wrapper">
    <div class="footer-grid">
      <div class="footer-item logo-container">
        <router-link to="/">
          <Logo/>
        </router-link>
      </div>
      <div class="footer-item copy-container">
        <h2>Questions?</h2>
        <h2>Suggestions?</h2>
        <h2>Contributions?</h2>
        <p>Email us at <a href="mailto:beamaskmaker@gmail.com" @click="logSocial('email')" target="_blank">beamaskmaker@gmail.com</a></p>
      </div>
      <div class="footer-item social-container">
        <h2>Follow us <br>on Instagram</h2>
        <a href="https://www.instagram.com/beamaskmaker/" @click="logSocial('instagram')" target="_blank" class="social instagram">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2500" width="2500" height="2500"><path d="M833.4,1250c0-230.11,186.49-416.7,416.6-416.7s416.7,186.59,416.7,416.7-186.59,416.7-416.7,416.7S833.4,1480.11,833.4,1250m-225.26,0c0,354.5,287.36,641.86,641.86,641.86S1891.86,1604.5,1891.86,1250,1604.5,608.14,1250,608.14,608.14,895.5,608.14,1250M1767.27,582.69a150,150,0,1,0,150.06-149.94h-0.06a150.07,150.07,0,0,0-150,149.94M745,2267.47c-121.87-5.55-188.11-25.85-232.13-43-58.36-22.72-100-49.78-143.78-93.5s-70.88-85.32-93.5-143.68c-17.16-44-37.46-110.26-43-232.13-6.06-131.76-7.27-171.34-7.27-505.15s1.31-373.28,7.27-505.15c5.55-121.87,26-188,43-232.13,22.72-58.36,49.78-100,93.5-143.78s85.32-70.88,143.78-93.5c44-17.16,110.26-37.46,232.13-43,131.76-6.06,171.34-7.27,505-7.27s373.28,1.31,505.15,7.27c121.87,5.55,188,26,232.13,43,58.36,22.62,100,49.78,143.78,93.5s70.78,85.42,93.5,143.78c17.16,44,37.46,110.26,43,232.13,6.06,131.87,7.27,171.34,7.27,505.15s-1.21,373.28-7.27,505.15c-5.55,121.87-25.95,188.11-43,232.13-22.72,58.36-49.78,100-93.5,143.68s-85.42,70.78-143.78,93.5c-44,17.16-110.26,37.46-232.13,43-131.76,6.06-171.34,7.27-505.15,7.27s-373.28-1.21-505-7.27M734.65,7.57c-133.07,6.06-224,27.16-303.41,58.06C349,97.54,279.38,140.35,209.81,209.81S97.54,349,65.63,431.24c-30.9,79.46-52,170.34-58.06,303.41C1.41,867.93,0,910.54,0,1250s1.41,382.07,7.57,515.35c6.06,133.08,27.16,223.95,58.06,303.41,31.91,82.19,74.62,152,144.18,221.43S349,2402.37,431.24,2434.37c79.56,30.9,170.34,52,303.41,58.06C868,2498.49,910.54,2500,1250,2500s382.07-1.41,515.35-7.57c133.08-6.06,223.95-27.16,303.41-58.06,82.19-32,151.86-74.72,221.43-144.18s112.18-139.24,144.18-221.43c30.9-79.46,52.1-170.34,58.06-303.41,6.06-133.38,7.47-175.89,7.47-515.35s-1.41-382.07-7.47-515.35c-6.06-133.08-27.16-224-58.06-303.41-32-82.19-74.72-151.86-144.18-221.43S2150.95,97.54,2068.86,65.63c-79.56-30.9-170.44-52.1-303.41-58.06C1632.17,1.51,1589.56,0,1250.1,0S868,1.41,734.65,7.57" fill="url(#0)"/><path d="M833.4,1250c0-230.11,186.49-416.7,416.6-416.7s416.7,186.59,416.7,416.7-186.59,416.7-416.7,416.7S833.4,1480.11,833.4,1250m-225.26,0c0,354.5,287.36,641.86,641.86,641.86S1891.86,1604.5,1891.86,1250,1604.5,608.14,1250,608.14,608.14,895.5,608.14,1250M1767.27,582.69a150,150,0,1,0,150.06-149.94h-0.06a150.07,150.07,0,0,0-150,149.94M745,2267.47c-121.87-5.55-188.11-25.85-232.13-43-58.36-22.72-100-49.78-143.78-93.5s-70.88-85.32-93.5-143.68c-17.16-44-37.46-110.26-43-232.13-6.06-131.76-7.27-171.34-7.27-505.15s1.31-373.28,7.27-505.15c5.55-121.87,26-188,43-232.13,22.72-58.36,49.78-100,93.5-143.78s85.32-70.88,143.78-93.5c44-17.16,110.26-37.46,232.13-43,131.76-6.06,171.34-7.27,505-7.27s373.28,1.31,505.15,7.27c121.87,5.55,188,26,232.13,43,58.36,22.62,100,49.78,143.78,93.5s70.78,85.42,93.5,143.78c17.16,44,37.46,110.26,43,232.13,6.06,131.87,7.27,171.34,7.27,505.15s-1.21,373.28-7.27,505.15c-5.55,121.87-25.95,188.11-43,232.13-22.72,58.36-49.78,100-93.5,143.68s-85.42,70.78-143.78,93.5c-44,17.16-110.26,37.46-232.13,43-131.76,6.06-171.34,7.27-505.15,7.27s-373.28-1.21-505-7.27M734.65,7.57c-133.07,6.06-224,27.16-303.41,58.06C349,97.54,279.38,140.35,209.81,209.81S97.54,349,65.63,431.24c-30.9,79.46-52,170.34-58.06,303.41C1.41,867.93,0,910.54,0,1250s1.41,382.07,7.57,515.35c6.06,133.08,27.16,223.95,58.06,303.41,31.91,82.19,74.62,152,144.18,221.43S349,2402.37,431.24,2434.37c79.56,30.9,170.34,52,303.41,58.06C868,2498.49,910.54,2500,1250,2500s382.07-1.41,515.35-7.57c133.08-6.06,223.95-27.16,303.41-58.06,82.19-32,151.86-74.72,221.43-144.18s112.18-139.24,144.18-221.43c30.9-79.46,52.1-170.34,58.06-303.41,6.06-133.38,7.47-175.89,7.47-515.35s-1.41-382.07-7.47-515.35c-6.06-133.08-27.16-224-58.06-303.41-32-82.19-74.72-151.86-144.18-221.43S2150.95,97.54,2068.86,65.63c-79.56-30.9-170.44-52.1-303.41-58.06C1632.17,1.51,1589.56,0,1250.1,0S868,1.41,734.65,7.57"/></svg>
        </a>
      </div>
    </div>
    <div class="footer-legal">
      <p>While these masks are intended to reduce the risk of getting and spreading the COVID-19 virus, the masks produced by these templates do not guarantee 100% protection from the virus. While we follow the CDC recommendations for wearing masks, please refer to the CDC website for information on mask recommendations and how to stay safe.</p>
    </div>
  </div>
</div>
</template>

<script>
import Logo from './Logo'

export default {
  components: {
    Logo
  },
  methods: {
    logSocial (type) {
      this.$gtm.trackEvent({
        event: 'customEvent',
        category: 'Social',
        action: 'Social Click - Footer',
        label: type,
        value: null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  width: 100%;
  margin-top: 100px;
  padding: 100px 40px;
  background: $gradient-footer;
  color: #fff;
  box-sizing: border-box;
  text-align: left;

  @media (max-width: 400px) {
    padding: 80px 25px;
  }

  h2, a {
    color: #fff;
  }

  h2 {
    text-transform: uppercase;
    margin: 0;
  }

  .footer-wrapper {
    max-width: 1200px;
    margin: 0 auto;

    @media screen and (max-width: $bp-m) {
      display: block;
    }
  }

  .footer-grid {
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: $bp-s) {
      display: block;
    }
  }

  .footer-item {
    padding: 0 10px;

    &:not(:last-of-type) {
      @media screen and (max-width: $bp-m) {
        margin-bottom: 50px;
      }
    }
  }

  .logo-container {
    width: 264px;
    margin-right: 6px;

    @media (max-width: 400px) {
      width: 200px;
    }

    /deep/ svg {
      width: 100%;

      path {
        fill: #fff;
      }
    }
  }

  .copy-container {
    text-align: left;

    a {
      text-decoration: underline;
      font-weight: bold;
    }
  }

  .disclaimer-container {
    p {
      max-width: 400px;
    }
  }

  .social-container {
    h2 {
      display: inline;
    }

    a {
      background-color: #87c7b3;
      margin: 10px 0 0;
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 10px 10px 31px -19px rgba(0,0,0,0.4);
      transition: .3s;

      &:hover {
        box-shadow: 10px 10px 31px -19px rgba(0,0,0,0.7);
        transition: .3s;
      }

      @media screen and (max-width: $bp-m) {
        margin: 10px 0 0;
      }

      path {
        fill: #fff;
      }

      svg {
        max-width: 45%;
        max-height: 45%;
      }
    }
  }

  .footer-legal {
    margin-top: 30px;
    max-width: 1000px;
    font-size: 16px;

    @media screen and (max-width: $bp-s) {
      margin-top: 56px;
    }
  }
}
</style>
